import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType, PlatformEvent } from "./PlatformEvent";
export var AudioSourceEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(AudioSourceEvent, _PlatformEvent);

  var _super = _createSuper(AudioSourceEvent);

  function AudioSourceEvent(eventName, audioSourceId) {
    var _this;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, AudioSourceEvent);

    _this = _super.call(this, eventName, eventType);
    _this.privAudioSourceId = audioSourceId;
    return _this;
  }

  _createClass(AudioSourceEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }]);

  return AudioSourceEvent;
}(PlatformEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceInitializingEvent = /*#__PURE__*/function (_AudioSourceEvent) {
  _inherits(AudioSourceInitializingEvent, _AudioSourceEvent);

  var _super2 = _createSuper(AudioSourceInitializingEvent);

  function AudioSourceInitializingEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceInitializingEvent);

    return _super2.call(this, "AudioSourceInitializingEvent", audioSourceId);
  }

  return AudioSourceInitializingEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceReadyEvent = /*#__PURE__*/function (_AudioSourceEvent2) {
  _inherits(AudioSourceReadyEvent, _AudioSourceEvent2);

  var _super3 = _createSuper(AudioSourceReadyEvent);

  function AudioSourceReadyEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceReadyEvent);

    return _super3.call(this, "AudioSourceReadyEvent", audioSourceId);
  }

  return AudioSourceReadyEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceOffEvent = /*#__PURE__*/function (_AudioSourceEvent3) {
  _inherits(AudioSourceOffEvent, _AudioSourceEvent3);

  var _super4 = _createSuper(AudioSourceOffEvent);

  function AudioSourceOffEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceOffEvent);

    return _super4.call(this, "AudioSourceOffEvent", audioSourceId);
  }

  return AudioSourceOffEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceErrorEvent = /*#__PURE__*/function (_AudioSourceEvent4) {
  _inherits(AudioSourceErrorEvent, _AudioSourceEvent4);

  var _super5 = _createSuper(AudioSourceErrorEvent);

  function AudioSourceErrorEvent(audioSourceId, error) {
    var _this2;

    _classCallCheck(this, AudioSourceErrorEvent);

    _this2 = _super5.call(this, "AudioSourceErrorEvent", audioSourceId, EventType.Error);
    _this2.privError = error;
    return _this2;
  }

  _createClass(AudioSourceErrorEvent, [{
    key: "error",
    get: function get() {
      return this.privError;
    }
  }]);

  return AudioSourceErrorEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeEvent = /*#__PURE__*/function (_AudioSourceEvent5) {
  _inherits(AudioStreamNodeEvent, _AudioSourceEvent5);

  var _super6 = _createSuper(AudioStreamNodeEvent);

  function AudioStreamNodeEvent(eventName, audioSourceId, audioNodeId) {
    var _this3;

    _classCallCheck(this, AudioStreamNodeEvent);

    _this3 = _super6.call(this, eventName, audioSourceId);
    _this3.privAudioNodeId = audioNodeId;
    return _this3;
  }

  _createClass(AudioStreamNodeEvent, [{
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }]);

  return AudioStreamNodeEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeAttachingEvent = /*#__PURE__*/function (_AudioStreamNodeEvent) {
  _inherits(AudioStreamNodeAttachingEvent, _AudioStreamNodeEvent);

  var _super7 = _createSuper(AudioStreamNodeAttachingEvent);

  function AudioStreamNodeAttachingEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeAttachingEvent);

    return _super7.call(this, "AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId);
  }

  return AudioStreamNodeAttachingEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeAttachedEvent = /*#__PURE__*/function (_AudioStreamNodeEvent2) {
  _inherits(AudioStreamNodeAttachedEvent, _AudioStreamNodeEvent2);

  var _super8 = _createSuper(AudioStreamNodeAttachedEvent);

  function AudioStreamNodeAttachedEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeAttachedEvent);

    return _super8.call(this, "AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId);
  }

  return AudioStreamNodeAttachedEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeDetachedEvent = /*#__PURE__*/function (_AudioStreamNodeEvent3) {
  _inherits(AudioStreamNodeDetachedEvent, _AudioStreamNodeEvent3);

  var _super9 = _createSuper(AudioStreamNodeDetachedEvent);

  function AudioStreamNodeDetachedEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeDetachedEvent);

    return _super9.call(this, "AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId);
  }

  return AudioStreamNodeDetachedEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeErrorEvent = /*#__PURE__*/function (_AudioStreamNodeEvent4) {
  _inherits(AudioStreamNodeErrorEvent, _AudioStreamNodeEvent4);

  var _super10 = _createSuper(AudioStreamNodeErrorEvent);

  function AudioStreamNodeErrorEvent(audioSourceId, audioNodeId, error) {
    var _this4;

    _classCallCheck(this, AudioStreamNodeErrorEvent);

    _this4 = _super10.call(this, "AudioStreamNodeErrorEvent", audioSourceId, audioNodeId);
    _this4.privError = error;
    return _this4;
  }

  _createClass(AudioStreamNodeErrorEvent, [{
    key: "error",
    get: function get() {
      return this.privError;
    }
  }]);

  return AudioStreamNodeErrorEvent;
}(AudioStreamNodeEvent);